module.exports = __webpack_public_path__ + "img/461.ff264414.png";